import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ContactsPage from './pages/ContactsPage';
import ContactDetailPage from './pages/ContactDetailPage';
import AccountsPage from './pages/AccountsPage';
import AccountDetailPage from './pages/AccountDetailPage';
import PipelinePage from './pages/PipelinePage';
import ActivityPage from './pages/ActivityPage';
import CalendarPage from './pages/CalendarPage';
import OutlookPage from './pages/OutlookPage';
import SettingsPage from './pages/SettingsPage';
import UsersPage from './pages/UsersPage';
import ImportPage from './pages/ImportPage';
import ReportsPage from './pages/ReportsPage';
import OpportunityDetailPage from './pages/OpportunityDetailPage';
import './App.css';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen">Loading…</div>;
  return user ? children : <Navigate to="/login" />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Navigate to="/dashboard" />} />
            <Route path="dashboard"  element={<DashboardPage />} />
            <Route path="contacts"   element={<ContactsPage />} />
            <Route path="contacts/:id" element={<ContactDetailPage />} />
            <Route path="accounts"   element={<AccountsPage />} />
            <Route path="accounts/:id" element={<AccountDetailPage />} />
            <Route path="pipeline"   element={<PipelinePage />} />
            <Route path="pipeline/:id" element={<OpportunityDetailPage />} />
            <Route path="activity"   element={<ActivityPage />} />
            <Route path="calendar" element={<CalendarPage />} />
            <Route path="outlook"    element={<OutlookPage />} />
            <Route path="settings"   element={<SettingsPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="import" element={<ImportPage />} />
            <Route path="reports" element={<ReportsPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}